import React from 'react';
import Button from 'components/button';
import EllipsisGroup from 'components/ellipsisGroup';

import { BackButtonContainer, Container, EllipsisContainer, NextButtonsContainer } from './styles';
import { isMobile } from 'react-device-detect';

interface IFooter {
  disabled?: boolean;
  hasBackButton?: boolean;
  steps: number;
  stepActive: number;
  onNextPress?: () => void;
  onBackPress?: () => void;
  nextLabel?: string;
  /** Shows the next button as busy, e.g. while the invites are sending. */
  loading?: boolean;
  /** Label for a dismiss button shown in place of Back. */
  dismissLabel?: string;
  /** Space above the footer; the design uses 20px under the access table, 30px elsewhere. */
  topGap?: number;
  onDismissPress?: () => void;
}

const Footer: React.FC<IFooter> = ({
  topGap,
  disabled,
  hasBackButton,
  steps,
  stepActive,
  onNextPress,
  onBackPress,
  nextLabel = 'Next',
  loading,
  dismissLabel,
  onDismissPress,
}) => {
  return (
    <Container $topGap={topGap}>
      <BackButtonContainer>
        {hasBackButton && (
          <Button $terciary icon="ArrowLeft" onClick={onBackPress} size={isMobile ? 'small' : null}>
            Back
          </Button>
        )}
        {!hasBackButton && dismissLabel && (
          <Button $secondary onClick={onDismissPress} size={isMobile ? 'small' : null}>
            {dismissLabel}
          </Button>
        )}
      </BackButtonContainer>
      <EllipsisContainer>
        <EllipsisGroup steps={steps} stepActive={stepActive} />
      </EllipsisContainer>
      <NextButtonsContainer>
        <Button
          data-testid="add-by-email-next-button"
          $primary
          onClick={onNextPress}
          disabled={disabled}
          loading={loading}
        >
          {nextLabel}
        </Button>
      </NextButtonsContainer>
    </Container>
  );
};

export default Footer;
